var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag.id,staticClass:"ml-2",attrs:{"label":"","x-small":""}},[_vm._v(_vm._s(tag.descricao))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }